import { render, staticRenderFns } from "./EditProjectModal.vue?vue&type=template&id=60c2e953"
import script from "./EditProjectModal.vue?vue&type=script&lang=js"
export * from "./EditProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports